
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurancesupersaver/[category]/[genericRoute]/[keyword]",
      function () {
        return require("private-next-pages/insurancesupersaver/[category]/[genericRoute]/[keyword].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insurancesupersaver/[category]/[genericRoute]/[keyword]"])
      });
    }
  